import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CuadreService } from '../../../services/cuadre.service';
import { Helper } from '../../../helpers/helper';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { ImageZoomModule } from 'angular2-image-zoom';
import * as moment from 'moment';
import { ConfiguracionesService } from '../../../services/configuraciones.service';
import { FormGroup, FormArray, FormControl } from '@angular/forms';
@Component({
  selector: 'app-cerrar-dia',
  templateUrl: './cerrar-dia.component.html',
  styleUrls: ['./cerrar-dia.component.css']
})
export class CerrarDiaComponent implements OnInit {
  @Input() apertura;
  @Input() modals;
  @Input() i;
  @Input() functions;
  datosCierre: any;
  gastos;
  loaded = false;
  loading = false;
  Verificado = false;
  recorrido = false;
  urlImg;
  editarMontoDinero = false;
  detalle_cierre = '';
  diferenciaCierre: number;
  editing = false;
  salida_detalle = '';
  loadingSalidaEfectivo = false;
  dinero_entrante: number;
  dinero_saliente: number;
  salida_monto: number;
  salidas_efectivo: number;
  fecha_apertura: string;
  cobros_extraordinarios: number;
  prestamos_extraordinarios: number;
  mora_extraordinaria: number;
  cuadre_v2: boolean;
  form: FormGroup;
  totalCalEfect = 0;
  constructor(
    public activeModal: NgbActiveModal,
    private cuadreService: CuadreService,
    public helper: Helper,
    public imageZoomModule: ImageZoomModule,
    private empleadoService: EmpleadosServicio,
    private configuracionesService: ConfiguracionesService) {
    this.configuracionesService
    .obtenerConfiguraciones()
    .subscribe((config: any) => this.cuadre_v2 = config.cuadre_v2)
    this.urlImg = this.helper.urlImg + 'cierre_dia/';
  }

  ngOnInit() {
    this.initCierre();
    this.initDenominacion();
    console.log(this.apertura);
    this.Verificado = this.apertura.estado === 2;
    const date = new Date(this.apertura.fecha_apertura);
    this.fecha_apertura = this.helper.daysWeek[date.getDay() + 1] + ', ' + (date.getDate() + 1) + ' de ' + this.helper.fullMonthNames[date.getMonth()].toLowerCase() + ' de ' + date.getFullYear();
  }

  onClickEditarMontoCapitalCierre() {

    if (this.datosCierre.capital >= 0) {
      this.editing = true;
      const data = {
        CIERRE_ID: this.datosCierre.ID_CIERRE_DIA,
        montoCapital: this.datosCierre.capital
      };
      this.cuadreService.actualizarCierreMontoCapitalIngresado(data)
      .subscribe(( resp: any) => {
        if (resp) {
          this.editarMontoDinero = false;
          this.setTotal();
        }
        this.editing = false;
      }, () => {
        this.editing = false;
      });
    }
  }

  onClickVerificado(event) {
    let data = {};

    if ( event.target.checked ) {
      this.Verificado = false;
      this.modals.agreeModal('Verificación',
      'Al hacer clic en esta casilla confirma haber validado la entrega de dicho monto en manos de la persona especificada o en la cuenta bancaria empresarial.', 'Continuar', 'green').then(resp => {
        // Verificada Params2: estado-> 0: Pendiente, 1: sin verificar, 2: verificada, 3: cerrad
        if (resp) {
          data = {id: this.datosCierre.ID_APERTURA_DIA, estado: 2, verificado_por: this.empleadoService.datosEmpleado.ID_EMPLEADO };
          this.Verificado = true;
        } else {
          data = {id: this.datosCierre.ID_APERTURA_DIA, estado: 1, verificado_por: this.empleadoService.datosEmpleado.ID_EMPLEADO};
          this.Verificado = false;

         }
         this.cuadreService.cambiarAperturaEstado(data).subscribe(( res: any) => {
          if (res) {
            this.apertura.estado = res.estado;
          }
        });
      });

    } else {
      // No Verificada
      data = {id: this.datosCierre.ID_APERTURA_DIA, estado: 1, verificado_por: this.empleadoService.datosEmpleado.ID_EMPLEADO};
      this.Verificado = false;
      this.cuadreService.cambiarAperturaEstado(data).subscribe(( resp: any) => {
        if (resp) {
          this.apertura.estado = resp.estado;
        }
      });
    }
  }

  private setTotal() {
    this.dinero_entrante = this.datosCierre.cobrado +
                          this.datosCierre.mora +
                          this.apertura.capital +
                          this.datosCierre.prestamos_nuevos +
                          this.datosCierre.renovaciones +
                          this.cobros_extraordinarios +
                          this.mora_extraordinaria;
    
    this.dinero_saliente = this.datosCierre.prestado +
                          this.gastos +
                          this.salidas_efectivo +
                          this.prestamos_extraordinarios;
                          
    this.diferenciaCierre = this.datosCierre.capital - (this.dinero_entrante - this.dinero_saliente);
  }

  private initCierre(): void {

    this.cuadreService.obtenerCierrePorApertura(this.apertura.ID_APERTURA_DIA)
    .subscribe((res: any) => {
      setTimeout(() => this.loaded = true, 1);
      if (res) {
        this.datosCierre = res;
        if (res.prestamos_extraordinarios) {
          this.prestamos_extraordinarios = res.prestamos_extraordinarios
          .reduce((a, b) => a + b.prestado, 0);
        }
        if (res.cobros_extraordinarios) {
          this.cobros_extraordinarios = res.cobros_extraordinarios
          .reduce((a, b) => a + b.cobrado, 0);
        }
        if (res.mora_extraordinaria) {
          this.mora_extraordinaria = res.mora_extraordinaria
          .reduce((a, b) => a + b.monto, 0);
        }
        this.gastos = res.gastos.reduce( (a, b) => a + b.capital, 0);
        this.salidas_efectivo = res.salidas_efectivo.reduce( (a, b) => a + b.capital, 0);

        this.setTotal();

        this.recorrido = this.datosCierre.recorridos > 0;
      }
    });

  }

  cerrarDia() {
    const currencyPipe = new CurrencyPipe('en-US');

    if (this.apertura.estado === 2) {

      const html =
      `<p>¿Desea cerrar el día con una diferencia de ${ currencyPipe.transform(this.diferenciaCierre,
        'RD$', 'symbol', '1.0-2') }?</p>`;
      this.modals.confirmNgbModal(html, 'Cuadre del Día')
      .then(resp => {
        if (resp && resp === 'si') {
          const data = {
            ID_EMPLEADO: this.empleadoService.datosEmpleado.ID_EMPLEADO,
            ID_CIERRE_DIA: this.datosCierre.ID_CIERRE_DIA,
            ID_APERTURA_DIA: this.datosCierre.ID_APERTURA_DIA,
            capital: this.apertura.capital,
            cobrado: this.datosCierre.cobrado,
            prestado: this.datosCierre.prestado,
            depositado: this.datosCierre.capital,
            gastos: this.datosCierre.gastos,
            prestamos_nuevos: this.datosCierre.prestamos_nuevos,
            renovaciones: this.datosCierre.renovaciones,
            mora: this.datosCierre.mora,
            cobros_extraordinarios: this.datosCierre.cobros_extraordinarios,
            prestamos_extraordinarios: this.datosCierre.prestamos_extraordinarios,
            mora_extraordinaria: this.datosCierre.mora_extraordinaria,
            diferencia: this.diferenciaCierre,
            detalle_cierre: this.detalle_cierre || '',
            cuota_anterior: this.datosCierre.cuota_anterior,
            cuota_actual: this.datosCierre.cuota_actual,
            anticipos: this.datosCierre.anticipos,
            variacion_atrasos: this.datosCierre.cuota_anterior - (this.datosCierre.cobrado - this.datosCierre.anticipos + this.datosCierre.cobros_ext),
            clientes_anterior: this.datosCierre.clientes_anterior,
            clientes_actual: this.datosCierre.clientes_actual,
            clientes_cobrado: this.datosCierre.estadistica_cobro.clientes_cobrados,
            clientes_anterior_porciento: (this.datosCierre.estadistica_cobro.clientes_cobrados / this.datosCierre.clientes_anterior),
            prestado_cobrado: this.datosCierre.prestado / this.datosCierre.cobrado,
            clientes_cobrado_porciento: this.datosCierre.estadistica_cobro.clientes_cobrados / (this.datosCierre.clientes_anterior + this.datosCierre.clientes_vencidos),
            hr_primer_cobro: moment(this.datosCierre.estadistica_cobro.primer_cobro).format(),
            hr_ultimo_cobro: moment(this.datosCierre.estadistica_cobro.ultimo_cobro).format(),
            hr_final_cobro: moment(this.datosCierre.estadistica_cobro.cierre_dia).format(),
            tiempo_total_cobro: this.datosCierre.estadistica_cobro.tiempo_total_cobro,
            dif_cierre_ultimo_cobro: this.datosCierre.estadistica_cobro.dif_cierre_ultimo_cobro,
            clientes_cobrados_12: this.datosCierre.estadistica_cobro.clientes_cobrados_12,
            clientes_cobrados_12_porciento: this.datosCierre.estadistica_cobro.clientes_cobrados_12 / this.datosCierre.clientes_anterior,
            velocidad_cobro_12: this.datosCierre.estadistica_cobro.clientes_cobrados_12 / this.datosCierre.estadistica_cobro.horas_hasta_12,
            velocidad_cobro: this.datosCierre.estadistica_cobro.clientes_cobrados / this. datosCierre.estadistica_cobro.tiempo_total_cobro,
            cuota_meta: this.datosCierre.cobro_meta,
            cuota_necesaria: this.datosCierre.cobro_meta - this.datosCierre.cuota_anterior,
            clientes_in_nuevos: this.datosCierre.clientes_nuevos,
            cuota_in_nuevos: this.datosCierre.clientes_nuevos_monto,
            clientes_in_renovacion: this.datosCierre.cliente_in_r,
            cuota_in_renovacion: this.datosCierre.cuota_in_r,
            clientes_out: this.datosCierre.cliente_out,
            cuota_out: this.datosCierre.cuota_out,
            cuota_in_out: this.datosCierre.cuota_actual - this.datosCierre.cuota_anterior,
            ncn: this.datosCierre.cobro_meta - this.datosCierre.cuota_actual,
            cobro_min: (( this.datosCierre.cobrado - this.datosCierre.anticipos) / (this.datosCierre.cuota_anterior + this.datosCierre.cuota_vencidos) ),
            clientes_nuevos_min: this.datosCierre.clientes_nuevos,
            aumento_cuota_min: this.datosCierre.cuota_actual - this.datosCierre.cuota_anterior > 0 ? 1 : 0,
            cobros_ext: this.datosCierre.cobros_ext,
            ID_RUTA: this.datosCierre.ID_RUTA,
          };
          this.loading = true;
          this.cuadreService.cerrarDia(data).subscribe(res => {
            setTimeout(() => this.loading = false, 1);
            this.activeModal.close(res);
            this.activeModal.close();
          });
        } else {
          this.loading = false;
          this.activeModal.close();
        }
      });
    }
  }

  verRecorrido(): void {
    this.activeModal.close();
    this.modals.recorridoNgbModal(this.datosCierre.ID_APERTURA_DIA)
    .then(() => {
      this.functions._parent.cerrarDia(this.apertura, this.i);
    });
  }

  registrarSalidaEfectivo() {
    this.loadingSalidaEfectivo = true;
    const data  = {
      ID_APERTURA_DIA: this.datosCierre.ID_APERTURA_DIA,
      capital: this.salida_monto,
      nota: this.salida_detalle
    };
    this.cuadreService.registrarSalidaEfectivo(data).subscribe((resp: any) => {
      this.datosCierre.salidas_efectivo.push(resp);
      this.loadingSalidaEfectivo = false;
      this.salida_detalle = '';
      this.salida_monto = null;
      this.salidas_efectivo += resp.capital;
      this.setTotal();

    }, () => {
      this.loadingSalidaEfectivo = false;
      this.modals.validacionesModalJquery('Error al comunicarse con el servidor. Favor de verificar su conexión a internet', '',
      'orange',
      'modern',
      false,
      'fa fa-wifi');
    });
  }

  eliminarSalidaEfectivo(item: any) {
    this.cuadreService.eliminarSalidaEfectivo(item.ID_APERTURA_DETALLE).subscribe((resp: any) => {
      if ( resp === 'OK') {
        const index =  this.datosCierre.salidas_efectivo.indexOf(item);
        if (index > -1) {
          this.datosCierre.salidas_efectivo.splice(index, 1);
          this.salidas_efectivo -= item.capital;
          this.setTotal();
        }
      }
    }, () => {
      this.modals.validacionesModalJquery('Error al comunicarse con el servidor. Favor de verificar su conexión a internet', '',
      'orange',
      'modern',
      false,
      'fa fa-wifi');
    });
  }

  time(date: string) {
    return !date ? '' : new DatePipe('en-US').transform(moment(date).format() , 'h:mm:s a');
  }

  dataV2(data: any[]) {
    if (this.cuadre_v2) {
      return data;
    }

    return [];
  }


  private initDenominacion() {
    this.form = new FormGroup({
      denominaciones: new FormArray([
        new FormGroup({
          cantidad: new FormControl(0),
          denominacion: new FormControl(2000)
        }),
        new FormGroup({
          cantidad: new FormControl(0),
          denominacion: new FormControl(1000)
        }),
        new FormGroup({
          cantidad: new FormControl(0),
          denominacion: new FormControl(500)
        }),
        new FormGroup({
          cantidad: new FormControl(0),
          denominacion: new FormControl(200)
        }),
        new FormGroup({
          cantidad: new FormControl(0),
          denominacion: new FormControl(100)
        }),
        new FormGroup({
          cantidad: new FormControl(0),
          denominacion: new FormControl(50)
        }),
        new FormGroup({
          cantidad: new FormControl(0),
          denominacion: new FormControl(25)
        }),
        new FormGroup({
          cantidad: new FormControl(0),
          denominacion: new FormControl(10)
        }),
        new FormGroup({
          cantidad: new FormControl(0),
          denominacion: new FormControl(5)
        }),
        new FormGroup({
          cantidad: new FormControl(0),
          denominacion: new FormControl(1)
        }),
      ])
    });

    this.form.valueChanges.subscribe(() => {
      const controls = (this.form.get('denominaciones') as FormArray).controls;

      this.totalCalEfect = controls.reduce((a , b) => a + (b.get('cantidad').value * b.get('denominacion').value), 0);
    });
  }


}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/cerrar-dia/cerrar-dia.component.ts